import { useCallback, useEffect, useRef, useState } from 'react';
/**
 *
 */
export default function useCaptionTimeout(hideCaption, options = {}) {
    const { delayCaption } = options || {};
    const [isCaptionHidden, setIsCaptionHidden] = useState(hideCaption);
    const timeoutRef = useRef(undefined);
    useEffect(() => {
        /** Delay caption hide when autoplayed - hideCaption changes */
        if (timeoutRef.current) {
            clearTimeout(timeoutRef.current);
        }
        if (hideCaption) {
            timeoutRef.current = setTimeout(setIsCaptionHidden, delayCaption || 0, true);
        }
        else {
            setIsCaptionHidden(false);
        }
        return () => {
            if (timeoutRef.current) {
                clearTimeout(timeoutRef.current);
            }
        };
    }, [hideCaption, delayCaption]);
    const onMouseEnter = useCallback(() => {
        /** Show caption for certain time on mouse over */
        if (timeoutRef.current) {
            clearTimeout(timeoutRef.current);
        }
        setIsCaptionHidden(false);
        timeoutRef.current = setTimeout(setIsCaptionHidden, delayCaption || 2000, hideCaption);
        return () => {
            if (timeoutRef.current) {
                clearTimeout(timeoutRef.current);
            }
        };
    }, [hideCaption, delayCaption]);
    const onMouseLeave = useCallback(() => setIsCaptionHidden(hideCaption), [hideCaption]);
    return [isCaptionHidden, { onMouseEnter, onMouseLeave }];
}
